/**
 * 基类
 *@author kyy
 *@date 2021/4/1 15:08
 */
import { Vue } from 'vue-class-component';

export class BaseViewModel extends Vue {
  user: any; // 用户信息
}
